var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 79,
    viewBox: "0 0 95 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.91 61.8101L34.37 77.4101M28.91 61.8101H39.44M28.91 61.8101H20.72M34.37 77.4101H8.53366C8.00373 77.4101 7.62806 76.893 7.79185 76.389L12.3549 62.349C12.4593 62.0277 12.7588 61.8101 13.0967 61.8101H20.72M34.37 77.4101L39.44 61.8101M34.37 77.4101H61.67M39.44 61.8101H47.825M56.21 61.8101L61.67 77.4101M56.21 61.8101H66.74M56.21 61.8101H47.825M61.67 77.4101H87.8963C88.4263 77.4101 88.8019 76.893 88.6381 76.389L84.0751 62.349C83.9707 62.0277 83.6712 61.8101 83.3333 61.8101H75.32M61.67 77.4101L66.74 61.8101M66.74 61.8101H75.32M75.32 61.8101L70.0353 45.5787C69.9308 45.2575 69.6314 45.0401 69.2937 45.0401H61.67M20.72 61.8101L26.0047 45.5787C26.1092 45.2575 26.4086 45.0401 26.7463 45.0401H34.37M47.825 61.8101L53.48 45.0401M47.825 61.8101L42.56 45.0401M53.48 45.0401H42.56M53.48 45.0401H61.67M42.56 45.0401H34.37M61.67 45.0401L56.3903 29.5781C56.2825 29.2623 55.9858 29.0501 55.6521 29.0501H40.011C39.671 29.0501 39.3702 29.2703 39.2674 29.5944L34.37 45.0401M77.66 45.0401H93.65M66.74 25.9301L78.44 14.2301M48.02 17.7401V1.36014M29.3 25.5401L17.99 14.2301M18.77 44.6501H2",
    stroke: "white",
    strokeWidth: 2.34,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon-2.d464d3f0966ffaf7711d5b5c30d9a5cf.svg";
export { ForwardRef as ReactComponent };